export function USP() {
	// https://linear.app/tosize/issue/TOS-2835/categorie-productcards-daadwerkelijke-levertijd-communiceren#comment-1c3a44fe
	return null;

	// const intl = useIntl();
	// const { carrierCode } = useConfig();
	// const { productData } = useProducts();
	// const { country } = separateLocale(intl.locale);
	// const date = productData?.fastestDeliveryDate
	// 	? formatRelativeDate({
	// 			lang: intl.locale,
	// 			date: productData?.fastestDeliveryDate,
	// 			showAll: false,
	// 		})
	// 	: undefined;

	// if (!date) {
	// 	return null;
	// }

	// return (
	// 	<DialogButton
	// 		title={intl.formatMessage({ defaultMessage: "Onze levertijd",  })}
	// 		content={match(country)
	// 			.with("nl", "be", () =>
	// 				intl.formatMessage({
	// 					defaultMessage:
	// 						"Op basis van snelst leverbare plaatgrootte en transport. Vul de volledige winkelwagen voor meer informatie over de daadwerkelijke levering.",
	//
	// 				}),
	// 			)
	// 			.otherwise(() =>
	// 				intl.formatMessage({
	// 					defaultMessage:
	// 						"Op basis van snelst leverbare plaatgrootte en transport met DPD. Maximale lengte is 130,0 cm, maximaal gewicht per item is 15 kg. Grote en zwaardere afmetingen hebben een langere levertijd door afwijkende levercondities qua inkoop en transporteur. Vul de volledige winkelwagen voor meer informatie over de daadwerkelijke levering.",
	//
	// 				}),
	// 			)}
	// 	>
	// 		<Button
	// 			variant="link"
	// 			starticon={faCheckCircle}
	// 			iconSize="default"
	// 			className="flex items-center text-success-medium"
	// 		>
	// 			{match([intl.locale, carrierCode])
	// 				.with(
	// 					["nl-nl", P._],
	// 					["de-de", "gstalt_vdhoef"],
	// 					["nl-be", "gstalt_vdhoef"],
	// 					["fr-be", "gstalt_vdhoef"],
	// 					["en-be", "gstalt_vdhoef"],
	// 					() =>
	// 						intl.formatMessage(
	// 							{ defaultMessage: "Vanaf {date} bezorgd",  },
	// 							{ date },
	// 						),
	// 				)
	// 				.otherwise(() =>
	// 					intl.formatMessage(
	// 						{ defaultMessage: "Vanaf {date} bezorgd via pakketpost",  },
	// 						{ date },
	// 					),
	// 				)}
	// 		</Button>
	// 	</DialogButton>
	// );
}
